import * as React from "react";
import { Tooltip } from 'react-tooltip';
import CoughAnalysisSetUtilities from "../../Shared/CoughAnalysisSetUtilities";
import { AnalysisSetReferenceTag } from "../../Shared/AnalysisSetReferenceTag";
import { AnalysisSetLink, CoughAnalysisSet } from "webportalclient";

interface CoughAnalysisSetTypeDisplayProps {
    analysisSet: CoughAnalysisSet;
}

const getInfo = (analysisSet: CoughAnalysisSet) => {
    const sourceAnalysisSetLink = CoughAnalysisSetUtilities.GetSourcedFromLink(analysisSet);

    const createdFromAnalysisSetLink = CoughAnalysisSetUtilities.GetCreatedFromLink(analysisSet);

    const toolTipId = `analysisSetTooltip-${analysisSet.id}`;
    const tooltip = (set: AnalysisSetLink) => <Tooltip id={toolTipId} style={{ zIndex: 2500 }}>
        <AnalysisSetReferenceTag typeName={set?.linkTypeName} coughSetTypeName={set?.targetCoughType} created={set?.targetCreated} status={set?.targetStatusName} />
    </Tooltip>

    if (sourceAnalysisSetLink) {
        return (<>{tooltip(sourceAnalysisSetLink)}<span className="label label-info" data-tooltip-id={toolTipId}>Linked</span></>);
    }

    if (createdFromAnalysisSetLink) {
        return (<>{tooltip(createdFromAnalysisSetLink)}<span className="fas fa-info-circle" data-tooltip-id={toolTipId}></span></>);
    }

    return null;
}

const CoughAnalysisSetTypeDisplay = ({ analysisSet }: CoughAnalysisSetTypeDisplayProps): JSX.Element => {
    return (<>
        {analysisSet.typeName} {getInfo(analysisSet)}
    </>)

};

export default CoughAnalysisSetTypeDisplay;
